<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">So Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="from_date"/> ~ <CustomDatePicker v-model="to_date"/></span>
				<em class="lt_text">Last Work Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="date"/></span>
				<a href="javascript:void(0);" class="search_bt mgr_15" @click="selectData()">Search</a>
				<a v-if="auth_for_goal" href="javascript:void(0);" class="gray_bt" @click="gotoStatusOfGoal">Status of Goal</a>
			</div>
		</div>

		<div class="half_tbl_box fixed-table-container mgb_10">
			<div class="left_big3_tbl table-wrapper" style="height:710px; overflow: auto">
				<h4 class="inner_h5">
					Packing
					<span style="float: right"> Count : {{ root && Array.isArray(root.packing_list) ? root.packing_list.length : 0 }} </span>
				</h4>
				<table class="list_tbl tbl_pointer sticky_list_tbl">
					<colgroup>
						<col v-if="profile.use_temp_flag == 'Y'" style="width: 3%;" />
						<col style="width: 11%;" />
						<col style="width: 13%;" />
						<col style="width: 13%;" />
						<col style="width: 15%;" />
						<col style="width: 18%;" />
						<col style="width: 15%;" />
						<col style="width: 15%;" />
					</colgroup>
					<thead>
						<tr>
							<th v-if="profile.use_temp_flag == 'Y'">GA</th>
							<th>Bill To</th>
							<th>So No</th>
							<th>So Date</th>
							<th>Status</th>
							<th>Approval Time</th>
							<th>Quantity(Valid)</th>
							<th>Amount(Valid)</th>
						</tr>
					</thead>
					<tbody v-if="root && Array.isArray(root.packing_list)">
						<tr v-for="invoice in root.packing_list" :key="invoice.invoice_no">
							<td v-if="profile.use_temp_flag == 'Y'">
								<font color="blue">{{ invoice.temp_flag ? 'GA' : '' }}</font>
							</td>
							<td :style="invoice.designated ? 'background: lightgreen;' : ''">{{ invoice.bill_to_code }}</td>
							<td :style="invoice.designated ? 'background: lightgreen;' : ''">{{ invoice.so_dn }}</td>
							<td class="al_center" :style="invoice.designated ? 'background: lightgreen;' : ''">{{ invoice.so_date }}</td>
							<td class="al_center" :style="invoice.designated ? 'background: lightgreen;' : ''">{{ invoice.packing_status }}</td>
							<td class="al_center" :style="invoice.designated ? 'background: lightgreen;' : ''">{{ invoice.approval_dt }}</td>
							<td class="al_right" :style="invoice.designated ? 'background: lightgreen;' : ''">{{ invoice.total_quantity | commaSeparated }}</td>
							<td class="al_right" :style="invoice.designated ? 'background: lightgreen;' : ''">{{ invoice.total_amount | toCurrency }}</td>
						</tr>
						<tr>
							<td v-if="profile.use_temp_flag == 'Y'"></td>
							<td colspan="5" class="al_right">Grand Total</td>
							<td class="al_right">{{ root.packing_list_value.quantity | commaSeparated }}</td>
							<td class="al_right">{{ root.packing_list_value.amount | toCurrency }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="right_small3_tbl table-wrapper" style="height:710px; overflow: auto;">
				<div>
					<h4 class="inner_h5">
						Approved but not printed
						<span style="float: right"> Count : {{ root && Array.isArray(root.approved_list) ? root.approved_list.length : 0 }} </span>
					</h4>
					<table class="list_tbl tbl_pointer sticky_list_tbl">
						<colgroup>
							<col v-if="profile.use_temp_flag == 'Y'" style="width: 3%;" />
							<col style="width: 15%;" />
							<col style="width: 15%;" />
							<col style="width: 15%;" />
							<col style="width: 25%;" />
							<col style="width: 15%;" />
							<col style="width: 15%;" />
						</colgroup>
						<thead>
							<tr>
								<th v-if="profile.use_temp_flag == 'Y'">GA</th>
								<th>Bill To</th>
								<th>So No</th>
								<th>So Date</th>
								<th>Approval Time</th>
								<th>Quantity(Valid)</th>
								<th>Amount(Valid)</th>
							</tr>
						</thead>
						<tbody v-if="root && Array.isArray(root.approved_list)">
							<tr v-for="invoice in root.approved_list" :key="invoice.invoice_no">
								<td v-if="profile.use_temp_flag == 'Y'">
									<font color="blue">{{ invoice.temp_flag ? 'GA' : '' }}</font>
								</td>
								<td :style="invoice.designated ? 'background: lightgreen;' : ''">{{ invoice.bill_to_code }}</td>
								<td :style="invoice.designated ? 'background: lightgreen;' : ''">{{ invoice.so_dn }}</td>
								<td class="al_center" :style="invoice.designated ? 'background: lightgreen;' : ''">{{ invoice.so_date }}</td>
								<td class="al_center" :style="invoice.designated ? 'background: lightgreen;' : ''">{{ invoice.approval_dt }}</td>
								<td class="al_right" :style="invoice.designated ? 'background: lightgreen;' : ''">{{ invoice.total_quantity | commaSeparated }}</td>
								<td class="al_right" :style="invoice.designated ? 'background: lightgreen;' : ''">{{ invoice.total_amount | toCurrency }}</td>
							</tr>
							<tr>
								<td v-if="profile.use_temp_flag == 'Y'"></td>
								<td colspan="4" class="al_right">Grand Total</td>
								<td class="al_right">{{ root.approved_list_value.quantity | commaSeparated }}</td>
								<td class="al_right">{{ root.approved_list_value.amount | toCurrency }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<div class="mgb_10" style="overflow: hidden;">
			<div class="right_small_tbl mgr_15">
				<table v-if="root && root.packingInfoWithStatusWI" class="list_tbl" style="margin: 0px;">
					<colgroup>
						<col style="width: 34%;" />
						<col style="width: 33%;" />
						<col style="width: 33%;" />
					</colgroup>
					<thead>
						<tr>
							<th>Type</th>
							<th>Count</th>
							<th>Amount</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="al_center bg_none">6:00 PM</td>
							<td class="al_right bg_none">{{ root.packingInfoWithStatusWI.before_invoice_count | commaSeparated }}</td>
							<td class="al_right bg_none">{{ root.packingInfoWithStatusWI.before_invoice_amount | toCurrency }}</td>
						</tr>
						<tr>
							<td class="al_center bg_none">After 6:00 PM</td>
							<td class="al_right bg_none">{{ root.packingInfoWithStatusWI.after_invoice_count | commaSeparated }}</td>
							<td class="al_right bg_none">{{ root.packingInfoWithStatusWI.after_invoice_amount | toCurrency }}</td>
						</tr>
						<tr>
							<td class="al_center bg_none">Packed</td>
							<td class="al_right bg_none">{{ root.packingInfoWithStatusWI.packed_count | commaSeparated }}</td>
							<td class="al_right bg_none">{{ root.packingInfoWithStatusWI.packed_amount | toCurrency }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="reportPrint">Print</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { apiPackingStatus } from '@/api/report/report';
import { apiGetReportTemplate, exportFile, objectToFormData, Report, reportMrtUrl } from '@/api/util';
import { lastWorkingDay } from '@/utils/date';
import CustomDatePicker from '@/components/common/CustomDatePicker';

export default {
	data: function() {
		return {
			root: {},

			date: lastWorkingDay(),
			from_date: lastWorkingDay(),
			to_date: lastWorkingDay(),

			searchDate: '',
			reportData: '',
		};
	},
	computed: {
		auth_for_goal() {
			const menus = this.$session.get('menus');
			return menus.some(menu => menu.path === '/warehouse/status_of_goal' && menu.view_yn === 'Y');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	methods: {
		async selectData() {
			const paramObj = { date: this.date, from_date: this.from_date, to_date: this.to_date };
			const param = objectToFormData(paramObj);
			const { data } = await apiPackingStatus(param);
			this.root = data.value;
			this.searchDate = data.date;
			this.reportData = data;
			console.log(data);
		},
		async Excel() {
			this.root.type = 'excel';
			const reportTemplate = await apiGetReportTemplate('PackingStatus', reportMrtUrl('PackingStatus'));
			const report = new Report(reportTemplate, this.reportData, 'PackingStatus');
			exportFile(report, 'excel');
		},
		async reportPrint() {
			// console.log(JSON.stringify(this.reportData, null, 4));
			this.root.type = 'print';
			let report_name = 'PackingStatus';
			if (this.user.company_id == 'beautyplus') report_name = 'PackingStatus_temp_flag';
			const reportTemplate = await apiGetReportTemplate(report_name, reportMrtUrl(report_name));
			const report = new Report(reportTemplate, this.reportData, report_name);
			this.$store.commit('setReport', report);
		},
		gotoStatusOfGoal() {
			let routeData = this.$router.resolve({ name: 'StatusOfGoal' });
			window.open(routeData.href, 'warehouse_status_of_goal');
		},
	},
	components: {
		CustomDatePicker,
	},
	mounted() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_packingStatus');
		this.$store.commit('setSubTitle', 'Report -> Packing Status');
	},
};
</script>

<style scoped></style>
